<template>
  <div class="ContractUs">
    <div class="appoint-wrap-success" v-show="isContract"></div>
    <div class="dialog-cont" v-show="isContract">
      <div class="logo-div tc">
        <img class="dialog-logo" src="@/common/images/leveing/web/1@2x.png" alt="" />
      </div>
      <div class="tc media-tit">联系我们</div>
      <div class="tc">
        <img class="code-img block" src="@/common/images/leveing/web/wx-code.jpg" alt="" />
        <div class="ft16 mb20">咨询电话：
          <a href="tel:13066904312" class="col-blue">13066904312</a>
        </div>
      </div>
      <div class="contract-close" @click="cancel"><img class="dialog-logo" src="@/common/images/leveing/web/cancel-icon.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      isContract:{
        type:Boolean,
        default:false,
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel',false)
      }
    },
  }
</script>

<style scoped lang='scss' type="css/scss">
.ContractUs {

.appoint-wrap-success{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background:#000;
    opacity:.8;
    z-index: 26;
  }
.dialog-cont{
    width: calc(100% - 40px);
    max-width: 400px;
    margin-left: 10px;
    padding: 0 10px;
    border-radius: 10px;
    z-index: 26;
    min-height: 260px;
    max-height: 400px;
    background: #fff;
    position: fixed;
    bottom: 10px;
    position: fixed;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -200px;
    .logo-div{
      width: 80px;
      height: 80px;
      line-height: 80px;
      margin-top: -50px;
      background: #fff;
      padding: 10px;
      border-radius: 50%;
      -webkit-box-shadow: 0 0 5px #ccc;
      box-shadow: 0 0 5px #ccc;
      position: absolute;
      left: 50%;
      margin-left: -45px;
      img{
        width: 50px;
        height: 40px;
        margin-top: 16px;
        margin-left: 15px;
      }
    }
    .dialog-logo{
      width: 30px;
      height: 30px;
      margin-top: 10px;
      cursor: pointer;
    }
    .close{
      position: absolute;
      top: -48px;
      right: 0px;
      i{
        font-size: 40px;
      }
    }
    .media-tit{
      color: #333;
      font-weight: bold;
      font-size: 18px;
      margin: 70px auto 20px;
    }
    .list{
      max-height: 220px;
      overflow-y: scroll;
      margin-bottom: 50px;
    }
    .a-item{
      padding-bottom: 6px;
      margin-bottom: 6px;
      border-bottom:1px solid #eee;
    }
    .title{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 26px;
    }
    .btm-hide{
      position: absolute;
      bottom: 0;
      line-height: 30px;
      background: #fff;
      text-align: center;
      padding: 10px 0;
      width: calc(100% - 20px);
    }
    .code-img{
      width: 170px;
      height: 170px;
      margin: 20px auto;
    }
}
@media (max-width: 1500px) {
    .dialog-cont {
        top: 60%;
    }
}

.contract-close{
    position: absolute;
    right: 4px;
    top: -48px;
    z-index: 68;
    img{
      width: 30px !important;
      height: 30px !important;;
    }
  }
}
</style>